import {
  Col,
  Divider,
  Row,
  Space,
  Segmented,
  Spin,
  Table,
  Tag,
  Typography,
  Modal,
  Rate,
  Button,
  Badge,
} from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import Link from 'antd/lib/typography/Link';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { NumberParam, useQueryParams } from 'use-query-params';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import ReviewPreview from '../../../../components/molecules/ReviewPreview/ReviewPreview';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import {
  AlignLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ExclamationCircleOutlined,
  RetweetOutlined,
  StarFilled,
  EyeOutlined,
} from '@ant-design/icons';
import { PeerReviewModel } from '../peer-reviews/PeerReviews';
import { RichText } from '../../../../components/RichText/RichText';
import ReactHtmlParser from '../../../../utils/SafeHtmlParser';
import { useHistory, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
const { confirm } = Modal;
const { Title, Text } = Typography;

const regex = /(<([^>]+)>)/gi;

const SinglePeerReviewsApprove: FC = () => {
  const [query, setQuery] = useQueryParams({
    cycle: NumberParam,
  });
  const params = useParams<{ user: string; name: string }>();
  const cycleRef = useRef(query.cycle);
  const user = useUserInfo();
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterType, setFilterType] = useState<string>('all');
  const [loading1, setLoading1] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [peerData, setPeerData] = useState<any>([]);
  const [filterTableData, setFilterTableData] = useState<any>([]);
  const [filterUser, setFilterUser] = useState<string>(params?.user);
  const [record, setRecord] = useState<undefined | any>(undefined);
  const [criteria, setCriteria] = useState<any>([]);
  const [showContent, setShowContent] = useState<boolean>(true);
  const connection = useConnection();
  const history = useHistory();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [submitData, setSubmitData] = useState<PeerReviewModel>({
    criteriaSet: [],
    overallComment: '',
    submitTime: '',
    cycle: query?.cycle,
    submittingUser: 0,
    peerReviewType: true,
  });

  const onSelectChange = useCallback((newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: any) => ({
      disabled: record.status !== 'submitted', // Column configuration not to be checked
      name: record.id,
    }),
  };

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setQuery(
              {
                cycle: value.closestCycle.id,
              },
              'replace',
            );
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, filterUser, setQuery]);

  useEffect(() => {
    setLoading(true);
    if (query?.cycle) {
      connection
        .get(`goals/review/user/approve/${query?.cycle}/${filterUser}`)
        .then((users: any) => {
          setPeerData(users.peers);
          setFilterTableData(users.reviewingUsers.map((e: any) => ({ ...e, key: e.id })));
          setFilterUser(filterUser);
          setCriteria(
            users.reviewingUsers?.[0]?.criteriaSet?.criterias?.map((e: any) => ({
              description: e.description,
              id: e.id,
              name: e.name,
              type: e.type,
            })) ?? [],
          );
          // setGoalSummary(goalSummary);
          // setValue(goalSummary?.criteriaSetId ?? 0);
        })
        .finally(() => setLoading(false));
    }
  }, [connection, query?.cycle, fetching, filterUser]);

  const createPeerReview = useCallback(
    (data?: any) => {
      setLoading1(true);
      setLoading(true);
      if (data?.criteriaSet?.length !== 0 || submitData?.criteriaSet?.length !== 0) {
        connection
          .patch(
            `goals/review/user/approve/${data ? data.id : record?.id}`,
            data
              ? {
                  answers: data?.criteriaSet?.map((e: any) => ({
                    id: e.id,
                    answer: ((e.answer ?? 0) / e.type) * 100,
                    comment: e.comment,
                  })),
                  overallComment: data?.overallComment,
                  peerReviewType: data?.peerReviewType ?? true,
                }
              : {
                  answers: submitData?.criteriaSet?.map((e) => ({
                    id: e.id,
                    answer: ((e.answer ?? 0) / e.type) * 100,
                    comment: e.comment,
                  })),
                  overallComment: submitData?.overallComment,
                  peerReviewType: submitData?.peerReviewType ?? true,
                },
          )
          .then(() => {
            window.onbeforeunload = null;
            setModalVisible(false);
            setSubmitData({
              criteriaSet: [],
              overallComment: '',
              submitTime: '',
              cycle: query?.cycle,
              submittingUser: 0,
              peerReviewType: true,
            });
            setFetching(!fetching);
            setRecord(undefined);
            setLoading1(false);
          })
          .catch(() => setLoading1(false))
          .finally(() => setLoading(false));
      } else {
        setLoading1(false);
      }
    },
    [submitData, connection, record?.id, query?.cycle, fetching],
  );

  const multiApprovePeerReview = useCallback(() => {
    setLoading1(true);
    setLoading(true);
    connection
      .patch(`goals/review/user/multi/approve`, {
        data: filterTableData
          .filter((e: any) => selectedRowKeys.find((n) => n === e.id))
          .map((k: any) => ({
            id: k.id,
            cycle: query?.cycle,
            submittingUser: user?.userId,
            submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            criteriaSet: k?.criteriaSet?.criterias.map((d: any) => ({
              ...d,
              answer: d.answer === 0 ? 1 : d.answer,
            })),
            overallComment: k?.overallComment ?? '',
            peerReviewType: k?.peerReviewType ?? true,
          }))
          .map((f: any) => ({
            id: f.id,
            answers: f?.criteriaSet?.map((e1: any) => ({
              id: e1.id,
              answer: ((e1.answer ?? 0) / e1.type) * 100,
              comment: e1.comment,
            })),
            overallComment: f?.overallComment,
            peerReviewType: f?.peerReviewType ?? true,
          })),
      })
      .then(() => {
        window.onbeforeunload = null;
        setModalVisible(false);
        setSubmitData({
          criteriaSet: [],
          overallComment: '',
          submitTime: '',
          cycle: query?.cycle,
          submittingUser: 0,
          peerReviewType: true,
        });
        setFetching(!fetching);
        setRecord(undefined);
        setLoading1(false);
        setSelectedRowKeys([]);
      })
      .catch(() => setLoading1(false))
      .finally(() => setLoading(false));
  }, [connection, filterTableData, selectedRowKeys, query?.cycle, user?.userId, fetching]);

  const rejectPeerReview = useCallback(
    (data?: any) => {
      setLoading1(true);
      setLoading(true);
      if (data?.criteriaSet?.length !== 0 || submitData?.criteriaSet?.length !== 0) {
        connection
          .patch(`goals/review/user/reject/${data ? data?.id : record?.id}`, {
            peerReviewType: data
              ? data?.peerReviewType ?? true
              : submitData?.peerReviewType ?? true,
          })
          .then(() => {
            window.onbeforeunload = null;
            setModalVisible(false);
            setSubmitData({
              criteriaSet: [],
              overallComment: '',
              submitTime: '',
              cycle: query?.cycle,
              submittingUser: 0,
              peerReviewType: true,
            });
            setFetching(!fetching);
            setRecord(undefined);
            setLoading1(false);
          })
          .catch(() => setLoading1(false))
          .finally(() => setLoading(false));
      } else {
        setLoading1(false);
      }
    },
    [
      submitData?.criteriaSet?.length,
      submitData?.peerReviewType,
      connection,
      record?.id,
      query?.cycle,
      fetching,
    ],
  );

  const showApproveModal = useCallback(
    (data?: any) => {
      confirm({
        title: 'Approving this review',
        icon: <ExclamationCircleOutlined />,
        content: `If you approve you won't be able to change`,
        okText: `Approve`,
        centered: true,
        okType: 'primary',
        cancelText: 'Cancel',
        onOk() {
          if (data) {
            setSubmitData({
              ...data,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
            createPeerReview({
              ...data,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
          } else {
            setSubmitData({
              ...submitData,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
            createPeerReview();
          }
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    [createPeerReview, query?.cycle, submitData, user?.userId],
  );

  const showApproveModal1 = useCallback(() => {
    confirm({
      title: 'Approving selected reviews',
      icon: <ExclamationCircleOutlined />,
      content: `If you approve you won't be able to change`,
      okText: `Approve`,
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        multiApprovePeerReview();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [multiApprovePeerReview]);

  const showRejectModal = useCallback(
    (data?: any) => {
      confirm({
        title: 'Rejecting this review',
        icon: <ExclamationCircleOutlined />,
        content: `Do you want reject this peer review`,
        okText: `Reject`,
        centered: true,
        okType: 'primary',
        okButtonProps: {
          danger: true,
        },
        cancelText: 'Cancel',
        onOk() {
          if (data) {
            setSubmitData({
              ...data,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
            rejectPeerReview({
              ...data,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
          } else {
            setSubmitData({
              ...submitData,
              cycle: query?.cycle,
              submittingUser: user?.userId,
              submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
            });
            rejectPeerReview();
          }
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    [query?.cycle, rejectPeerReview, submitData, user?.userId],
  );

  const columns = useMemo(() => {
    return [
      {
        title: 'Reviewer',
        dataIndex: 'reviewerName',
        key: 'reviewerName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'user'} src={record.reviewerImage} />
            <Typography>{text}</Typography>
          </Space>
        ),
      },
      // {
      //   title: 'Team',
      //   dataIndex: 'teamName',
      //   key: 'teamName',
      //   // eslint-disable-next-line react/display-name
      //   render: (text: string, record: any) => (
      //     <Space>
      //       <UserAvatar type={'team'} src={record.teamImage} />
      //       <Typography>{text}</Typography>
      //     </Space>
      //   ),
      // },
      ...criteria.map((e: any) => ({
        title: e.name,
        dataIndex: 'criteria' + e.id,
        key: 'criteria' + e.id,
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <Rate
              value={record.criteriaSet.criterias.find((m: any) => m.id == e.id)?.answer ?? 0}
              character={<StarFilled style={{ fontSize: 15 }} />}
              count={e.type}
              disabled={record.status !== 'submitted'}
              onChange={(value) =>
                setFilterTableData(
                  filterTableData.map((k: any) =>
                    k.id === record.id
                      ? {
                          ...k,
                          criteriaSet: {
                            ...k.criteriaSet,
                            criterias: k.criteriaSet.criterias.map((j: any) =>
                              j.id === e.id ? { ...j, answer: value } : j,
                            ),
                          },
                        }
                      : k,
                  ),
                )
              }
            />
          </Space>
        ),
      })),
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {(record.status == '' ||
              record.status == 'not submitted' ||
              record.status === 'drafted') && <Tag color={'blue'}>Not submitted</Tag>}
            {record.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
            {record.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
            {record.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
          </Space>
        ),
      },
      {
        title: 'Overall Score',
        dataIndex: 'marks',
        key: 'marks',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {!(
              record.status == '' ||
              record.status == 'not submitted' ||
              record.status === 'drafted'
            ) && (
              <>
                <Badge
                  count={
                    record.criteriaSet.criterias.reduce(
                      (x: any, y: any) => x + (y.answer / y.type) * 100,
                      0,
                    ) /
                      record.criteriaSet.criterias.length +
                    '%'
                  }
                  showZero
                  overflowCount={120}
                  style={{ fontSize: '16px' }}
                  color={
                    record.criteriaSet.criterias.reduce(
                      (x: any, y: any) => x + (y.answer / y.type) * 100,
                      0,
                    ) /
                      record.criteriaSet.criterias.length >
                    85
                      ? '#52c41a'
                      : record.criteriaSet.criterias.reduce(
                          (x: any, y: any) => x + (y.answer / y.type) * 100,
                          0,
                        ) /
                          record.criteriaSet.criterias.length >
                        60
                      ? '#faad14'
                      : ''
                  }
                />
              </>
            )}
          </Space>
        ),
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {!(
              record.status == '' ||
              record.status == 'not submitted' ||
              record.status === 'drafted'
            ) && (
              <>
                <Button
                  type="text"
                  shape="circle"
                  icon={<EyeOutlined />}
                  size={'middle'}
                  onClick={() => {
                    setSubmitData({
                      ...submitData,
                      criteriaSet: record?.criteriaSet?.criterias,
                      overallComment: record?.overallComment ?? '',
                      peerReviewType: record?.peerReviewType ?? true,
                    });
                    window.onbeforeunload = function () {
                      return 'Data will be lost if you leave the page, are you sure?';
                    };
                    setModalVisible(true);
                    setRecord(record);
                  }}
                />
                <Button
                  type="text"
                  shape="circle"
                  icon={<CheckCircleOutlined />}
                  onClick={() => {
                    showApproveModal({
                      ...submitData,
                      id: record.id,
                      criteriaSet: record?.criteriaSet?.criterias,
                      overallComment: record?.overallComment ?? '',
                      peerReviewType: record?.peerReviewType ?? true,
                    });
                  }}
                  size={'middle'}
                />
                <Button
                  type="text"
                  shape="circle"
                  icon={<StopOutlined />}
                  size={'middle'}
                  onClick={() => {
                    showRejectModal({
                      ...submitData,
                      id: record.id,
                      criteriaSet: record?.criteriaSet?.criterias,
                      overallComment: record?.overallComment ?? '',
                      peerReviewType: record?.peerReviewType ?? true,
                    });
                  }}
                />
              </>
            )}
          </Space>
        ),
      },
    ];
  }, [criteria, filterTableData, showApproveModal, showRejectModal, submitData]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${params.name} Peer Review Approvals`}
        subTitle="Moderate peer reviews"
        onBack={() => history.goBack()}
        breadcrumb={{
          items: [
            {
              path: '',
              title: `Peer Review Approvals`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            <CycleToggle
              value={parseInt(`${query?.cycle}`)}
              onChange={(value) =>
                setQuery(
                  {
                    cycle: value,
                  },
                  'replace',
                )
              }
              data={cycles}
            />
          </FlexBox>
          <Spin spinning={loading}>
            <FlexBox
              style={{
                marginBottom: '10px',
                alignItems: 'end',
                justifyContent: 'space-between',
              }}>
              {peerData.length > 0 && (
                <Space>
                  <UserAvatar
                    type={'user'}
                    size={100}
                    src={peerData.find((e: any) => +e.id === +params.user)?.image}
                  />
                  <Title level={5} style={{ marginRight: '10px' }}>
                    {params.name}
                  </Title>
                </Space>
              )}
              <Space direction="vertical">
                <Segmented
                  options={[
                    {
                      label: 'All',
                      value: 'all',
                    },
                    {
                      label: 'Not submitted',
                      value: 'not submitted',
                    },
                    // {
                    //   label: 'Pending Approval',
                    //   value: 'pending approval',
                    // },
                    {
                      label: 'Submitted',
                      value: 'submitted',
                    },
                    {
                      label: 'Rejected',
                      value: 'rejected',
                    },
                    {
                      label: 'Approved',
                      value: 'approved',
                    },
                  ]}
                  onChange={(e) => {
                    setFilterType(e as string);
                    setSelectedRowKeys([]);
                  }}
                />
              </Space>
            </FlexBox>
            <Table
              size="small"
              columns={columns}
              dataSource={
                filterType === 'all'
                  ? filterTableData
                  : filterType === 'pending approval'
                  ? filterTableData.filter((e: any) => e.status !== 'approved')
                  : filterTableData.filter((e: any) => e.status === filterType)
              }
              expandable={{ indentSize: 0 }}
              pagination={false}
              rowSelection={{
                type: 'checkbox',
                ...rowSelection,
              }}
            />
            <FlexBox style={{ marginTop: '1%', alignItems: 'center', justifyContent: 'right' }}>
              <Button
                key="multi-submit"
                type="primary"
                disabled={selectedRowKeys.length === 0}
                loading={loading1}
                onClick={() => showApproveModal1()}>
                Approve
              </Button>
            </FlexBox>
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
      <Modal
        destroyOnClose={true}
        visible={modalVisible}
        onCancel={() => {
          setRecord(undefined);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: query?.cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          window.onbeforeunload = null;
          setModalVisible(false);
          // events.emit('PEER_REVIEW_CLOSE');
        }}
        footer={
          record?.status == 'approved'
            ? [
                <Button
                  key="cancel"
                  type="default"
                  disabled={loading1}
                  onClick={() => {
                    setRecord(undefined);
                    setSubmitData({
                      criteriaSet: [],
                      overallComment: '',
                      submitTime: '',
                      cycle: query?.cycle,
                      submittingUser: 0,
                      peerReviewType: true,
                    });
                    window.onbeforeunload = null;
                    setModalVisible(false);
                    // events.emit('PEER_REVIEW_CLOSE');
                  }}>
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  disabled={
                    submitData?.overallComment === '' ||
                    submitData?.criteriaSet?.length === 0 ||
                    submitData?.criteriaSet?.findIndex(
                      (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
                      // e.comment === '' ||
                      // e.comment === null ||
                      // e.comment === undefined,
                    ) !== -1
                  }
                  loading={loading1}
                  onClick={() => showApproveModal()}>
                  Re-Submit
                </Button>,
              ]
            : [
                <Button
                  key="cancel"
                  type="default"
                  disabled={loading1}
                  onClick={() => {
                    setRecord(undefined);
                    setSubmitData({
                      criteriaSet: [],
                      overallComment: '',
                      submitTime: '',
                      cycle: query?.cycle,
                      submittingUser: 0,
                      peerReviewType: true,
                    });
                    window.onbeforeunload = null;
                    setModalVisible(false);
                    // events.emit('PEER_REVIEW_CLOSE');
                  }}>
                  Cancel
                </Button>,
                <Button key="reject" danger loading={loading1} onClick={() => showRejectModal()}>
                  Reject
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  disabled={
                    submitData?.overallComment === '' ||
                    submitData?.criteriaSet?.length === 0 ||
                    submitData?.criteriaSet?.findIndex(
                      (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
                      // e.comment === '' ||
                      // e.comment === null ||
                      // e.comment === undefined,
                    ) !== -1
                  }
                  loading={loading1}
                  onClick={() => showApproveModal()}>
                  Approve
                </Button>,
              ]
        }>
        <Row style={{ marginTop: '3%' }}>
          <UserAvatar src={record?.peerImage ?? null} size={80} />
          <Col style={{ marginLeft: '3%' }}>
            <Title level={3} style={{ margin: 0 }}>
              {record?.peerName}
            </Title>
            <Text type="secondary">{record?.peerDesignation}</Text>
            <div>
              <Tag color="blue">{record?.teamName}</Tag>
            </div>
          </Col>
        </Row>
        <Divider style={{ marginTop: '2%' }} />
        <div style={{ marginLeft: '1%' }}>
          <ReviewPreview
            mode={record?.mode}
            criterias={record?.criteriaSet?.criterias}
            onChange={(val) =>
              setSubmitData({
                ...submitData,
                criteriaSet: val,
              })
            }
          />
        </div>
        <Space style={{ marginTop: '2%' }}>
          <StarFilled style={{ color: 'red', fontSize: 7, paddingRight: 5 }} />
          <AlignLeftOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          <Text type="secondary">Overall Comment</Text>
        </Space>
        <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
        <div style={{ marginTop: '2%' }}>
          <RichText
            placeholder={'Add your overall comment'}
            value={submitData?.overallComment}
            maxLength={10000}
            onChange={(e) => setSubmitData({ ...submitData, overallComment: e })}
          />
        </div>
        <Row style={{ alignItems: 'center', marginTop: 20 }}>
          <Space>
            <Title level={5}>Activity</Title>
            <RetweetOutlined style={{ fontSize: 20 }} />
          </Space>
        </Row>
        <Link onClick={() => setShowContent(!showContent)}>
          <Space className="div_hover">
            <Text>Show Activities</Text>
            {!showContent ? (
              <CaretDownOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            ) : (
              <CaretUpOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            )}
          </Space>
        </Link>
        {record?.peerReviewHistory?.length !== 0 &&
          showContent &&
          record?.peerReviewHistory?.map((item: any, key: any) => {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.image} />
                    <Text strong>{item?.name}</Text>
                    <Text type="secondary">{item.date}</Text>
                  </Space>
                </Row>
                <Row>
                  <Text strong>
                    Status:
                    {(record.status == '' ||
                      record.status == 'not submitted' ||
                      record.status === 'drafted') && <Tag color={'blue'}>Not submitted</Tag>}
                    {item.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                    {item.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
                    {item.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
                  </Text>
                </Row>
                {item?.status === 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 20 }}>
                          <Text type="secondary">{`Submitted ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                {item?.status !== 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 10 }}>
                          <Text type="secondary">{`Updated ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Rate
                                value={(e.oldAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                              <ArrowRightOutlined
                                style={{ paddingTop: 6, paddingLeft: 15, paddingRight: 15 }}
                              />
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>

                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Modal>
    </WebUxPage>
  );
};

export default SinglePeerReviewsApprove;
